const baseURL = process.env.REACT_APP_API || window.location.origin + '/api/'

export function post(url, data) {
  return fetch(baseURL + url, {
    body: JSON.stringify(data),
    headers: {
      'content-type': 'application/json'
    },
    method: 'POST',
  }).then(res => res.json())
}

export function get(url) {
  return fetch(baseURL + url, {
    method: 'GET',
  }).then(res => res.json())
}
export { default as companyNew } from "./companyNew"
export { default as policyStudy } from "./policyStudy"
export { default as IndustryNews } from "./IndustryNews"
export { default as join } from "./join"
export { default as InvestorApi } from "./Investor"
